const ArticleNewImageModal = ({ isOpen, onClose, imageSrc }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-40 flex items-center justify-center bg-black bg-opacity-50" onClick={onClose}>
            <div className="container relative w-full p-4 pt-10 bg-white rounded-lg shadow-lg">
                <button
                    className="absolute z-50 text-2xl top-2 right-2"
                    onClick={onClose}
                >
                    <i className="text-4xl font-bold ri-close-line" />
                </button>
                <div>
                    <img src={imageSrc} className="max-h-[90vh] w-full mt-2" alt="Selected" />
                </div>

            </div>
        </div>
    )
}

export default ArticleNewImageModal